const ITEMS = ["Haircuts", "Styling", "Hair Care", "Grooming", "Gandhi Nagar", "Hyderabad"];

export const Marquee = ({ dark = true }) => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className={`font-display font-extrabold uppercase tracking-[0.25em] text-sm sm:text-base px-6 ${dark ? "text-white/70" : "text-ink/70"}`}>
            {t}
          </span>
          <span className="font-editorial italic text-copper text-xl" aria-hidden="true">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      aria-hidden="true"
      className={`overflow-hidden py-5 border-y ${dark ? "bg-ink border-copper/15" : "bg-ivory border-ink/10"}`}
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
};
